import { DndContext, DragEndEvent } from "@dnd-kit/core";
import {
  restrictToParentElement,
  restrictToVerticalAxis,
} from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { IOrderable } from "./interfaces";
import OrderableItem from "./OrderableItem";

interface IProps<T> extends IOrderable<T> {
  items: T[];
  parentId?: string;
}

const OrderableItems = <T,>({
  items,
  setItems,
  parentId,
  idKey,
  nameKey,
  nestedDataKey,
}: IProps<T>) => {
  const keys = items?.map((item) => idKey(item));

  const handleDragEnd = ({ active, over }: DragEndEvent): void => {
    if (!over || active.id === over.id) return;

    const oldIndex = keys.indexOf(active.id.toString());
    const newIndex = keys.indexOf(over.id.toString());

    const updatedItems = arrayMove(items, oldIndex, newIndex);

    setItems(updatedItems, parentId);
  };

  if (!items?.length) return null;

  return (
    <DndContext
      onDragEnd={handleDragEnd}
      modifiers={[restrictToVerticalAxis, restrictToParentElement]}
    >
      <SortableContext items={keys} strategy={verticalListSortingStrategy}>
        <ul className={`list-none ${!parentId ? "inline-block pl-0" : ""}`}>
          {items.map((item) => (
            <OrderableItem
              key={idKey(item)}
              item={item}
              idKey={idKey}
              nameKey={nameKey}
              nestedDataKey={nestedDataKey}
              setItems={setItems}
              orderingDisabled={items.length === 1}
            />
          ))}
        </ul>
      </SortableContext>
    </DndContext>
  );
};

export default OrderableItems;
